import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const Circle = ({ label, sub, positionClass, delay }) => (
  <div className={`absolute ${positionClass}`}>
    <motion.div
      initial={{ opacity: 0, scale: 0.85 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1.2, delay, ease: EASE }}
      className="w-52 h-52 md:w-72 md:h-72 rounded-full border-2 border-amber-500/40 bg-amber-500/[0.04] mix-blend-screen flex items-center justify-center"
    >
      <div className="text-center px-4">
        <p className="font-serif text-xl md:text-2xl text-amber-200/90">{label}</p>
        <p className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-slate-400 mt-2 leading-relaxed">
          {sub}
        </p>
      </div>
    </motion.div>
  </div>
);

const Triad = () => (
  <div
    data-testid="triad-visual"
    className="relative h-[440px] md:h-[560px]"
  >
    <Circle
      label="Designer"
      sub="Understand people"
      positionClass="left-1/2 top-0 -translate-x-[85%] md:-translate-x-[105%]"
      delay={0}
    />
    <Circle
      label="Architect"
      sub="Reuse what exists"
      positionClass="left-1/2 top-0 -translate-x-[15%] md:translate-x-[5%]"
      delay={0.2}
    />
    <Circle
      label="Developer"
      sub="Evaluate the full canvas"
      positionClass="left-1/2 top-[42%] md:top-[38%] -translate-x-1/2"
      delay={0.4}
    />
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, delay: 0.9 }}
      className="absolute left-1/2 top-[26%] md:top-[24%] -translate-x-1/2 z-10 text-center pointer-events-none"
    >
      <p className="font-mono-tech text-[10px] md:text-xs tracking-[0.35em] uppercase text-gold">
        Human-Centered
      </p>
      <p className="font-mono-tech text-[10px] md:text-xs tracking-[0.35em] uppercase text-gold mt-1">
        Design
      </p>
    </motion.div>
  </div>
);

export default Triad;
